import { Injectable } from '@angular/core';

import { Adapter } from './adapter';

import { Session } from '@/core/models/session.model';

@Injectable({
  providedIn: 'root',
})
export class SessionAdapter implements Adapter<Session> {
  adapt(item: any): Session {
    return new Session(
      item?.access_token || null,
      item?.refresh_token || null,
    );
  }
}
